
import { HttpResponse } from "@microsoft/signalr";
import { AwardTypes } from "API/Generated/AwardTypes";
import { Pageant } from "API/Generated/Pageant";
import { PageantAvailableTitle } from "API/Generated/PageantAvailableTitle";
import { RegisteredContestantAwardRelationship } from "API/Generated/RegisteredContestantAwardRelationship";
import { Tabulation } from "API/Generated/Tabulation";
import { runInAction } from "mobx";

//Lifecycle of tabulation:
// ----------------QUESTIONS BEFORE CONTRACT---------------
// - Are you using our registration?
// - Are you requring contestants to register themselves into the system or am i putting them in?
// - Are you using our emcee sheets?
// - Number of Days of Event
// - Date and Location?
// - Do you hand out score sheets?
// -----------------TABULATION CONTRACT----------------
// - Agree on price and expectations - Sign Contract
// - Get paperwork: list of packages, awards: titles, side awards, jackpots etc, areas of competition, age groups, supreme groups, levels, styles
// - Get award scoring and contestant criteria
// - After Deposit: Send questionaire form with all questions (create an online form at some point)
//----------------QUESTIONS FOR DIRECTOR---------------
// - Is it a crown all?
// - Are pluses allowed?
// - Is Glitz/Natural separate?
// - Are Boys awards separate?
// - What is your "too high" and "too low" score checks?
// - Which awards are "double crown" - a contestant can win this award along with other awards?
// - What are all the scoring categories for all aocs, min and max score?
// - Is decimal points permitted?
// - Supreme Scoring Settings
// - Are you awarding a top 10 of whole pageant or a top in levels, supreme groups, styles, etc?
// - Besides side award what other awards?  best in aocs?, will there be a first, second third?
// - Order you want crowning ceremony to be called
//--------------BEFORE EVENT--------------
// - Create all packages, awards, and aocs
// - Add awards and aocs to packages
// - Add Judges to pageant
// - Set all scoring categories for all AOCs
// - Set all awards contestant and scoring criterias
// - Give Director a full PDF rundown of ALL packages, aocs, awards and all criteria TO SIGN**
//--------------------AT EVENT----------------
// - Check if all contestants are registered
// - Check if all their selections are current and acurrate
// - Confirm with director the Contestant List is ACCURATE - every contestant is accounted for**
// - Create all award relationship records - Button
// - Update all Is Entered and Meets Criteria on all records - Button
// - Check that all contestants have the correct aocs they are competing in
// - Enter all scores for all contestants and all aocs
// ----------------RUN AUDIT CHECKS------------------
// - Run Award Relationships Audit Check: that all award relationships are created, isEntered and meetsCriteria is set (SYNC ALL AWARD RELATIONSHIP RECORDS)
// - Run Awards list Audit Check:Do all titles have contestant and scoring criteria, is all criteria accurate, is double crown titles correct
// - Run Score Aduit Check: do all contestants have received scores from all judges on all entered aocs and are they not too high or too low
// -------------------AFTER AUDITS PASS-------------------------
// - ReSync Button: update or create any missing award relationship records, update isEntered and meetsCriteria on ALL
// - Last confirmation with Director that EVERYTHING is accurate: Contestants List, Titles List, AOCs List
// - Run Calculate Title Scores: settings title scores for ALL titles (titles only no side awards or jackpots)
// - Run Calculate Jackpot Scores: setting jackpot scores for ALL jackpots only
// - Run Calculate Side Award Scores: if ANY side awards have a scoring criteria, calculate score for that.
//-------------------RUN AWARD SCORE AUDIT CHECK------------------------
// - Does every award relationship record of awardTypeId 1 (title) has a title score?
// - Are any award scores too high or too low (determining on directors check request)
// -------------------------DETERMINE WINNERS-------------------
// - Run Determine Title WInners - button
// - Run Determine Double Crown Winners - button
// ---------------------FINAL AUDIT CHECK ON WINNERS------------------
// - Check if all contestants have a title (that is not double crown) IF pageant is a CROWN ALL
// - Check that no contestant has more than 1 title that are NOT double crown
// - Check that ALL award winners are ENTERED and ELIGIBLE to win that award
// - Check All Ties!
//-----------------------AFTER SUCCESSFUL AUDIT-----------------
// - Create Crowning Ceremony PDF, print and seal in envelope!
// - Print final event rundown
// - Print comparatives!


import { AwardTypeBaseModel, ContestantAttributesModel, ContestantComprehensiveTabulationResultNew, ContestantSupremeScoreResultOptimized, GeneralScoringCriteriaSettings, RegisteredContestantAwardRelationshipBaseModel, RegistrationInvoice, StaffTabulatorAccessCodesDTO, SupremeScoreResult } from "API/Generated/data-contracts";
import { ContestantCriteria, ScoringCriteria, SpecificAwardFullCriteria } from "data/TabulationDataProvider";
import { makeObservable, observable, action } from "mobx";


class TabulationStore {
  PageantAvailabeTitleService: PageantAvailableTitle = new PageantAvailableTitle();
  AwardTypesService: AwardTypes = new AwardTypes();
  RegisteredContestantAwardRelationshipService: RegisteredContestantAwardRelationship = new RegisteredContestantAwardRelationship();
  AwardTypeList: AwardTypeBaseModel[] = [];
  RegisteredContestantAwardRelationships: RegisteredContestantAwardRelationshipBaseModel[] = [];
  TabulationService: Tabulation = new Tabulation();

  ShowModal: boolean = false;
  AllowEdit: boolean = false;
  private isDataLogged: boolean = false;

  constructor(awardTypeList: AwardTypeBaseModel[], awardRelationships: RegisteredContestantAwardRelationshipBaseModel[] = []) {
    makeObservable(this, {
      AwardTypeList: observable,
      RegisteredContestantAwardRelationships: observable, // Keep this in sync if needed
      ShowModal: observable,
      AllowEdit: observable,
      // syncContestantAwards: action,
      setShowModal: action.bound,
      setAllowEdit: action.bound,
    });
    // makePersistable(this, {
    //     name: 'TabulationStore',
    //     properties: ['AwardTypeList', 'ShowModal', 'AllowEdit'],
    // });

    this.RegisteredContestantAwardRelationships = awardRelationships;
    this.AwardTypeList = awardTypeList;
  }




    //------------------FETCH TABULATION SUMMARY DYNAMICALLY START----------------


async getDynamicComprehensiveSummaries(params: {
  pageantId?: number;
  registeredContestantIds?: number[];
}): Promise<ContestantComprehensiveTabulationResultNew[]> {
  const { pageantId, registeredContestantIds } = params ?? {};
 console.log("getDynamicComprehensiveSummaries started");
  if ((!pageantId || pageantId <= 0) && !registeredContestantIds?.length) {
    console.warn("Provide pageantId and/or at least one registeredContestantId.");
    return [];
  }

  console.debug("getDynamicComprehensiveSummaries →", params);

  // The generated client with `format: 'json'` returns parsed JSON.
  const res = await this.TabulationService.dynamicComprehensiveTabulationsList({
    pageantId,
    registeredContestantIds,
  });

  // Depending on generator, this may be either the array itself or { data: T }
  const list =
    (Array.isArray(res) && res) ||
    (Array.isArray((res as any)?.data) && (res as any).data) ||
    [];

  console.debug("getDynamicComprehensiveSummaries count:", list.length);
  if (list.length) console.debug("getDynamicComprehensiveSummaries first item:", list[0]);

  return list;
}



  //------------------FETCH TABULATION SUMMARY DYNAMICALLY END----------------

  //------------------FETCH AREAS OF COMPETITION DYNAMICALLY START----------------
  //dynamically fetch pageant available aocs and filter by pageantId, aocTypeId, aocId, contestantId, packageId
  async getAvailableAOCDynamic(filters: {
    pageantId?: number;
    aocId?: number;
    aocTypeId?: number;
    registeredPageantContestantId?: number;
    pageantAvailablePackageId?: number;
  }): Promise<any[] | null> {
    try {
      const response = await this.TabulationService.getPageantAvailableAocDynamically(filters);

      if (!response.ok) {
        console.warn("Failed to fetch filtered pageant available aocs.", response.status);
        return null;
      }

      const data = await response.json();

      if (!data || !Array.isArray(data)) {
        return null;
      }

      return data;
    } catch (error) {
      console.error("Error fetching filtered pageant available aocs:", error);
      return null;
    }
  }

  //-------------------FETCH TITLE AND CORRESPONDING AWARD RELATIONSHIPS START------------------


  //dynamically fetch pageant available awards and filter by pageantId, awardTypeId, titleId, contestantId, packageId
  async getAvailableAwardsDynamic(filters: {
    pageantId?: number;
    titleId?: number;
    awardTypeId?: number;
    registeredPageantContestantId?: number;
    pageantAvailablePackageId?: number;
  }): Promise<any[] | null> {
    try {
      const response = await this.TabulationService.getPageantAvailableAwardsDynamically(filters);

      if (!response.ok) {
        console.warn("Failed to fetch filtered pageant available awards.", response.status);
        return null;
      }

      const data = await response.json();

      if (!data || !Array.isArray(data)) {
        return null;
      }

      return data;
    } catch (error) {
      console.error("Error fetching filtered pageant available awards:", error);
      return null;
    }
  }

  //dynamically fetch and sync award relationships to match awards
  async syncAwardsWithRelationshipsDynamic(filters: {
    pageantId?: number;
    pageantAvailableTitleId?: number;
    registeredPageantContestantId?: number;
  }): Promise<any[] | null> {
    try {
      const response = await this.TabulationService.tabulationSyncAwardRelationshipRecordsDynamically(filters);

      if (!response.ok) {
        console.warn("Failed to sync filtered pageant available awards.", response.status);
        return null;
      }

      const data = await response.json();

      if (!data || !Array.isArray(data)) {
        return null;
      }

      return data;
    } catch (error) {
      console.error("Error syncing filtered pageant available awards:", error);
      return null;
    }
  }

  //dynamically check and update entered, meets criteria, eligibility 
  async updateEligbilityFlagsDynamic(filters: {
    pageantId: number;
    pageantAvailableTitleId?: number;
    registeredPageantContestantId?: number;
  }): Promise<any[] | null> {
    try {
      const response = await this.TabulationService.tabulationUpdateEligibilityFlagsDynamicallyCreate(filters);

      if (!response.ok) {
        console.warn("Failed to update eligibility flags", response.status);
        return null;
      }

      const data = await response.json();

      if (!data || !Array.isArray(data)) {
        return null;
      }

      return data;
    } catch (error) {
      console.error("Error updating eligibility flags", error);
      return null;
    }
  }



  //-------------------FETCH TITLE AND CORRESPONDING AWARD RELATIONSHIPS END------------------
 
  //fetch dynamically and filter by titleId, contestantId, or pageantId
  async getAwardRelationshipsDynamic(filters: {
    registeredContestantId?: number;
    pageantAvailableTitleId?: number;
    pageantId?: number;
  }): Promise<any[] | null> {
    try {
      const response = await this.TabulationService.tabulationGetAwardRelationshipRecordsDynamically(filters);

      if (!response.ok) {
        console.warn("Failed to fetch filtered award relationships.", response.status);
        return null;
      }

      const data = await response.json();

      if (!data || !Array.isArray(data)) {
        return null;
      }

      return data;
    } catch (error) {
      console.error("Error fetching filtered award relationships:", error);
      return null;
    }
  }

  //-----------------FETCH RECEIVED SCORES DYNAMICALLY START-----------------
  async getReceivedScoresDynamically(filters: {
    pageantId?: number;
    registeredPageantContestantId?: number;
    judgeId?: number;
    aocId?: number;
    aocScoringCategoryId?: number;
  }): Promise<any[] | null> {
    try {
      const response = await this.TabulationService.getReceivedScoresDynamically(filters);

      if (!response.ok) {
        console.warn("Failed to fetch filtered received scores.", response.status);
        return null;
      }

      const data = await response.json();

      if (!data || !Array.isArray(data)) {
        return null;
      }

      return data;
    } catch (error) {
      console.error("Error fetching filtered received scores", error);
      return null;
    }
  }

  //Check dynamically if scores even exist and get counts

  async checkIfScoresExistDynamically(filters: {
    pageantId?: number;
    registeredPageantContestantId?: number;
    judgeId?: number;
    aocId?: number;
    aocScoringCategoryId?: number;
 }): Promise<boolean> {
  const res = await this.TabulationService.hasAnyScores(filters);
  if (!res.ok) {
    console.warn("Failed to check if scores exist.", res.status);
    return false;
  }
  const data = await res.json(); // backend returns true/false
  return Boolean(data);
}

    async getScoreCountDynamically(filters: {
    pageantId?: number;
    registeredPageantContestantId?: number;
    judgeId?: number;
    aocId?: number;
    aocScoringCategoryId?: number;
  }): Promise<any[] | null> {
    try {
      const response = await this.TabulationService.getScoreCount(filters);

      if (!response.ok) {
        console.warn("Failed to get score count.", response.status);
        return null;
      }

      const data = await response.json();

      if (!data || !Array.isArray(data)) {
        return null;
      }

      return data;
    } catch (error) {
      console.error("Error fetching score count", error);
      return null;
    }
  }



  async confirmWinner(awardRelationshipId: number): Promise<void> {
    try {
      await this.RegisteredContestantAwardRelationshipService.confirmWinnerUpdate(awardRelationshipId);
      console.log("Winner confirmed successfully.");
    } catch (error) {
      console.error("Error confirming winner:", error);
      throw error;
    }
  }

  async removeWinner(awardRelationshipId: number): Promise<void> {
    try {
      await this.RegisteredContestantAwardRelationshipService.removeWinnerDelete(awardRelationshipId);
      console.log("Winner removed successfully.");
    } catch (error) {
      console.error("Error removed winner:", error);
      throw error;
    }
  }

  //------------------GET AOC SCORING CATEGORIES-------------------

  //-------------Update Pull Order----------------
  async updateAwardPullOrderBulk(titles: { id: number; pullOrder: number }[]): Promise<void> {
    try {

      const response = await this.PageantAvailabeTitleService.updateAwardPullOrderCreate(titles);

      if (!response.ok) {
        throw new Error("Failed to update pull orders");
      }

      console.log("✅ Pull order update complete.");
    } catch (error) {
      console.error("❌ Error during pull order update:", error);
      throw error;
    }
  }

  //-------------------CALCULATE AND SAVE TITLE SCORES------------------


  //dynamically calculating and saving award scores and relationships based on contestantId, titleId, or pageantId
  async calculateAndSaveAwardScoresDynamic(filters: {
    registeredContestantId?: number;
    pageantAvailableTitleId?: number;
    pageantId?: number;
  }): Promise<any[] | null> {
    const start = performance.now(); // Start timing
    try {
      const response = await this.TabulationService.tabulationCalculateAwardScoresDynamically(filters);

      if (!response.ok) {
        console.warn("Failed to calculate award relationships.", response.status);
        return null;
      }

      const data = await response.json();

      if (!data || !Array.isArray(data)) {
        return null;
      }

      return data;
    } catch (error) {
      console.error("Error calculate award relationships:", error);
      return null;
    }
    finally {
      const end = performance.now(); // End timing
      console.log(`calculateAndSaveAwardScoresDynamic took ${(end - start).toFixed(2)}ms`);
    }
  }


  //dynamically calculating and saving awards that are using supreme score criteria by filters - testing
  async calculateAndSaveAwardScoresThatAreUsingSupremeScoreDynamic(filters: {
    registeredContestantId?: number;
    pageantAvailableTitleId?: number;
    pageantId?: number;
  }): Promise<any[] | null> {
    try {
      const response = await this.TabulationService.applySupremeScoresCreate(filters);

      if (!response.ok) {
        console.warn("Failed to save contestant supreme scores to awards that are using it", response.status);
        return null;
      }

      const data = await response.json();

      if (!data || !Array.isArray(data)) {
        return null;
      }

      return data;
    } catch (error) {
      console.error("Error saving contestant supreme scores to awards that are using it", error);
      return null;
    }
  }

  //pinpoint specific awards and/or contestants and calculate award scores dynamically fast
// keep this public signature so all existing call sites work
async PinPointCalculateAndSaveAwardScoresFast(filters: {
  registeredContestantId?: number[];   // singular key stays for callers
  pageantAvailableTitleId?: number[];  // singular key stays for callers
  pageantId?: number;
}): Promise<any[] | null> {
  const start = performance.now();
  try {
    // 🔁 map singular -> plural for the API
    const payload: {
      pageantId?: number;
      pageantAvailableTitleIds?: number[];
      registeredContestantIds?: number[];
    } = {
      pageantId: filters.pageantId,
      ...(filters.pageantAvailableTitleId?.length
        ? { pageantAvailableTitleIds: filters.pageantAvailableTitleId }
        : {}),
      ...(filters.registeredContestantId?.length
        ? { registeredContestantIds: filters.registeredContestantId }
        : {}),
    };

    const response = await this.TabulationService.pinPointCalculateAndSaveAwardScoresFast(payload);

    if (!response.ok) {
      console.warn("Failed to calculate award relationships.", response.status);
      return null;
    }

    const data = await response.json();
    return Array.isArray(data) ? data : null;
  } catch (error) {
    console.error("Error calculate award relationships:", error);
    return null;
  } finally {
    const end = performance.now();
    console.log(`PinPointCalculateAndSaveAwardScoresFast took ${(end - start).toFixed(2)}ms`);
  }
}




  //Get max possible points for award based on criteria
  async getMaxPossiblePointsForAward(
    pageantId: number,
    awardId: number
  ): Promise<ScoringCriteria> {
    try {
      // ⬇️ pass an object, not positional args
      const res = await this.TabulationService.getMaxPossiblePointsPerAward({
        pageantId,
        awardId,
      });
  
      // depending on your service, res may already be the data or under res.data
      const data = (res?.data ?? res) as ScoringCriteria;
      return data;
    } catch (error) {
      console.error('Error determining max possible points for award:', error);
      throw error;
    }
  }




  // tabulationStore.ts
  async fetchContestantTitleScoreDetails(contestantId: number, titleId: number): Promise<any> {
    try {
      const response = await this.TabulationService.tabulationCalculateContestantTitleScore(contestantId, titleId);

      if (!response.ok) {
        throw new Error(`HTTP error ${response.status}`);
      }

      const data = await response.json(); // ✅ <-- This is where the magic happens
      console.log("📦 Parsed breakdown data:", data);
      return data;
    } catch (error) {
      console.error("❌ Error fetching score breakdown:", error);
      throw error;
    }
  }




  //--------------------------DTERMINE TITLE WINNERS---------------------

  async determineWinnersCreate(pageantId: number): Promise<any[]> {
    try {
      const response = await this.RegisteredContestantAwardRelationshipService.determineWinnersCreate(pageantId);
      return (response as any);
    } catch (error) {
      console.error("Error determining winners:", error);
      throw error;
    }
  }

  async getContestantAttributesByPageant(pageantId: number): Promise<any[]> {
    try {
      //const response = await this.RegisteredContestantAwardRelationshipService.getContestantCriteriaAttributesByPageantIdNewList({ pageantId });

      const response = await this.TabulationService.getAllRegisteredContestantsAttributes(pageantId);

      // Cast the response to any type to access the properties without errors
      return (response as any).contestantsAttributes; // Use 'any' to avoid type issues
    } catch (error) {
      console.error("Error fetching contestant attributes:", error);
      throw error; // Rethrow the error for the caller to handle
    }
  }



  async updateAwardScore(contestantId: number, titleId: number, score: number): Promise<void> {
    try {
      // Construct the query object
      const query = {
        contestantId,
        titleId,
        score,
      };

      // Call the service method with the query object
      await this.RegisteredContestantAwardRelationshipService.updateAwardScoreUpdate(query);
      console.log(`Award score updated for contestant ID: ${contestantId}, title ID: ${titleId}, score: ${score}`);
    } catch (error) {
      console.error(`Error updating award score for contestant ID: ${contestantId}:`, error);
      throw error; // Rethrow or handle the error as needed
    }
  }


  // async resetAllAwardScoresInPageant(pageantId: number): Promise<void> {
  //   try {
  //     const response = await this.TabulationService.resetAllAwardScoresInPageantPageantIdDetail(pageantId);
  //     await response.json(); // optional if the result isn't used directly
  //     console.log(`Award scores reset for pageantId: ${pageantId}`);
  //   } catch (error) {
  //     console.error(`Error resetting award scores for pageantId: ${pageantId}:`, error);
  //     throw error;
  //   }
  // }

  //dynamically reset all the scores in aware relationships - testing
    async resetAwardRelationshipsScoresDynamic(filters: {
    pageantAvailableTitleIds?: number[];
    registeredContestantIds?: number[];
    pageantId?: number;
  }): Promise<any[] | null> {
    try {
      if (
        !filters?.pageantId &&
        !(filters?.pageantAvailableTitleIds && filters.pageantAvailableTitleIds.length)
      ) {
        console.warn("resetAwardRelationshipsScoresDynamic: missing filters.");
        return null;
      }

      const response = await this.TabulationService.tabulationResetAwardScoresDynamically(filters);

      if (!response.ok) {
        console.warn("Failed to reset award relationships.", response.status);
        return null;
      }

      const data = await response.json();

      if (!data || !Array.isArray(data)) {
        return null;
      }

      return data;
    } catch (error) {
      console.error("Error reset award relationships scores.", error);
      return null;
    }
  }

  async resetAllScoringCriteriaInPageant(pageantId: number): Promise<void> {
    try {
      const response = await this.TabulationService.resetAwardScoringCriteriaForPageantCreate({ pageantId });

      await response.json(); // optional if the result isn't used directly
      console.log(`Award scoring criteria reset for pageantId: ${pageantId}`);
    } catch (error) {
      console.error(`Error resetting award scoring criteria for pageantId: ${pageantId}:`, error);
      throw error;
    }
  }

  //dynamically reset award scores by pageant or by specific awards and update the award relationships to match/reset the score
  async resetAwardScoringCriteriaDynamic(filters: {
    pageantAvailableTitleIds?: number[];
    pageantId?: number;
  }): Promise<any[] | null> {
    try {
      if (
        !filters?.pageantId &&
        !(filters?.pageantAvailableTitleIds && filters.pageantAvailableTitleIds.length)
      ) {
        console.warn("ResetAwardScoringCriteriaDynamic: missing filters.");
        return null;
      }

      const response = await this.TabulationService.resetAwardScoringCriteriaDynamicCreate(filters);

      if (!response.ok) {
        console.warn("Failed to reset award scoring criteria and matching award relationships.", response.status);
        return null;
      }

      const data = await response.json();

      if (!data || !Array.isArray(data)) {
        return null;
      }

      return data;
    } catch (error) {
      console.error("Error reset award scoring criteria and matching award relationships.", error);
      return null;
    }
  }


  //----------------------SUPREME SCORING CRITERIA FOR A PAGEANT START-----------------
  async fetchSupremeScoringCriteria(pageantId: number): Promise<GeneralScoringCriteriaSettings | null> {
    try {
      if (!pageantId || pageantId <= 0) {
        console.error("Invalid pageant ID.");
        return null;
      }

      const response = await this.TabulationService.getSupremeScoringCriteriaDetail(pageantId);
      return response.data; // ✅ returning expected type
    } catch (error) {
      console.error(`❌ Failed to fetch Supreme Scoring Criteria for pageant ${pageantId}:`, error);
      return null; // ✅ returning fallback of correct type
    }
  }


  async fetchSupremeScoreBreakdownForContestant(pageantId: number): Promise<GeneralScoringCriteriaSettings | null> {
    try {
      if (!pageantId || pageantId <= 0) {
        console.error("Invalid pageant ID.");
        return null;
      }

      const response = await this.TabulationService.getSupremeScoringCriteriaDetail(pageantId);
      return response.data; // ✅ returning expected type
    } catch (error) {
      console.error(`❌ Failed to fetch Supreme Scoring Criteria for pageant ${pageantId}:`, error);
      return null; // ✅ returning fallback of correct type
    }
  }

  async calculateAndSaveAllSupremeScoresInPageant(
    pageantId: number
  ): Promise<ContestantSupremeScoreResultOptimized> {
    const start = performance.now();
    try {
      const response = await this.TabulationService.calculateAndSaveSupremeScoresCreate(pageantId);

      // Optional: validate structure here if needed
      return response as ContestantSupremeScoreResultOptimized;
    } catch (error) {
      console.error("Error calculating supreme scores:", error);
      throw error;
    } finally {
      const end = performance.now();
      console.log(`calculateSupremeScoresCreate took ${(end - start).toFixed(2)}ms`);
    }
  }

  //determine the selected aocs used towards the contestants supreme score based on supreme score criteria
  async determineContestantSelectedAocForSupremeScore(pageantId: number, contestantId: number): Promise<SupremeScoreResult | null> {
    try {
      if (!pageantId || pageantId <= 0) {
        console.error("Invalid pageant ID.");
        return null;
      }

      const response = await this.TabulationService.getUsedAoCsForSupremeScorePageantIdContestantIdDetail(pageantId, contestantId);
      return response.data; // ✅ returning expected type
    } catch (error) {
      console.error(`❌ Failed to determine the AOCs used toward supreme score for contestantId ${contestantId} in pageantId ${pageantId}:`, error);
      return null;
    }
  }

  //----------------------SUPREME SCORING CRITERIA FOR A PAGEANT END-----------------


  //-----------------------CONTESTANTS COMPREHENSIVE TABULATION FOR AOC AND AWARDS AND SUPREME SCORE------------
  async getComprehensiveContestantAOCResult(pageantId: number, contestantId: number): Promise<ContestantComprehensiveTabulationResultNew | null> {
    try {
      if (!pageantId || pageantId <= 0) {
        console.error("Invalid pageant ID.");
        return null;
      }

      const response = await this.TabulationService.getComprehensiveAocScoresForContestantDetail(pageantId, contestantId);
      return response.data;
    } catch (error) {
      console.error(
        `❌ Failed to store tabulation result for contestantId ${contestantId} in pageantId ${pageantId}:`,
        error
      );
      return null;
    }
  }

  async getComprehensiveContestantAwardResult(pageantId: number, contestantId: number): Promise<ContestantComprehensiveTabulationResultNew | null> {
    try {
      if (!pageantId || pageantId <= 0) {
        console.error("Invalid pageant ID.");
        return null;
      }

      const response = await this.TabulationService.getComprehensiveAwardsDetailsForContestantPageantIdContestantIdDetail(pageantId, contestantId);
      return response.data;
    } catch (error) {
      console.error(
        `❌ Failed to store tabulation result for contestantId ${contestantId} in pageantId ${pageantId}:`,
        error
      );
      return null;
    }
  }



    async getContestantRegistrationInvoice(pageantId: number, contestantId: number): Promise<RegistrationInvoice | null> {
    try {
      if (!pageantId || pageantId <= 0) {
        console.error("Invalid pageant ID.");
        return null;
      }

      const response = await this.TabulationService.getRegisteredContestantRegistrationInvoice(pageantId, contestantId);
      return response.data;
    } catch (error) {
      console.error(
        `❌ Failed to get registration invoice for contestantId ${contestantId} in pageantId ${pageantId}:`,
        error
      );
      return null;
    }
  }


    async getContestantAttributes(pageantId: number, contestantId: number): Promise<ContestantAttributesModel | null> {
    try {
      if (!pageantId || pageantId <= 0) {
        console.error("Invalid pageant ID.");
        return null;
      }

      const response = await this.TabulationService.getRegisteredContestantAttributes(pageantId, contestantId);
      return response.data;
    } catch (error) {
      console.error(
        `❌ Failed to get contestant attributes for contestantId ${contestantId} in pageantId ${pageantId}:`,
        error
      );
      return null;
    }
  }

  //----------------------ADD/EDIT AWARD SCORING CRITERIA FOR AN AWARD-----------------



  // ✅ Save Award Scoring Criteria - testing new version for universal for both any award AND supreme scoring
  async saveAwardScoringCriteria(
    awardId: number,
    criteria: ScoringCriteria
  ): Promise<void> {
    if (!Array.isArray(criteria.customRules)) {
      throw new Error(`customRules is missing or invalid: ${JSON.stringify(criteria)}`);
    }

    console.log("🔎 Received awardId:", awardId);
    console.log("📥 Received criteria:", criteria);

    const payload: GeneralScoringCriteriaSettings = {
      dropLowestScore: criteria.dropLowestScore,
      dropHighestScore: criteria.dropHighestScore,
      customRules: criteria.customRules.map((rule) => ({
        topN: rule.topN,
        aocIds: rule.aocIds ?? [],
        aocNames: rule.aocNames ?? [],
        selectedAocType: rule.selectedAocType ?? undefined,
        selectedAocTypeId: rule.selectedAocTypeId ?? undefined,
        maxCountForSelectedAocType:
          typeof rule.maxCountForSelectedAocType === 'string'
            ? parseInt(rule.maxCountForSelectedAocType as unknown as string, 10)
            : rule.maxCountForSelectedAocType ?? null,
        specificScoringCategoryIds: rule.scoringCategoryIds ?? [],
      })),
    };

    console.log("📦 Final payload being sent to backend:", JSON.stringify(payload, null, 2));

    await this.TabulationService.saveAwardScoringCriteriaCreate(
      payload,            // body
      { awardId }         // ?awardId=123
    );
  }

  // ✅ Save Supreme Scoring Criteria - testing
  async saveSupremeScoringCriteria(
    pageantId: number,
    criteria: ScoringCriteria
  ): Promise<void> {
    if (!Array.isArray(criteria.customRules)) {
      throw new Error(`customRules is missing or invalid: ${JSON.stringify(criteria)}`);
    }

    console.log("🔎 Received pageantId:", pageantId);
    console.log("📥 Received criteria:", criteria);

    const payload: GeneralScoringCriteriaSettings = {
      dropLowestScore: criteria.dropLowestScore,
      dropHighestScore: criteria.dropHighestScore,
      customRules: criteria.customRules.map((rule) => ({
        topN: rule.topN,
        aocIds: rule.aocIds ?? [],
        aocNames: rule.aocNames ?? [],
        selectedAocType: rule.selectedAocType ?? undefined,
        selectedAocTypeId: rule.selectedAocTypeId ?? undefined,
        maxCountForSelectedAocType:
          typeof rule.maxCountForSelectedAocType === 'string'
            ? parseInt(rule.maxCountForSelectedAocType as unknown as string, 10)
            : rule.maxCountForSelectedAocType ?? null,
        specificScoringCategoryIds: rule.scoringCategoryIds ?? [],
      })),
    };

    console.log("📦 Final payload being sent to backend:", JSON.stringify(payload, null, 2));

    await this.TabulationService.saveSupremeScoringCriteriaCreate(
      payload,            // body
      { pageantId }
    );
  }

  // ✅ Save Award Contestant Criteria - testing new version for universal for both any award AND supreme scoring

  async saveAwardContestantCriteria(
    awardId: number,
    criteria: ContestantCriteria | ContestantCriteria[]
  ): Promise<void> {
    if (!Array.isArray(criteria)) {
      throw new Error(`contestant criteria is missing or invalid: ${JSON.stringify(criteria)}`);
    }

    console.log("🔎 Received awardId:", awardId);
    console.log("📥 Received criteria:", criteria);

    const list = Array.isArray(criteria) ? criteria : [criteria];

    // Build the backend payload inline (List<ContestantCriteriaSetting>)
    const payload = list.map(c => ({
      awardIndex: Math.max(1, Number(c.awardIndex ?? 1)),
      specificCriterias: [
        {
          ageGroupIds: c.specificCriteria?.ageGroupIds ?? [],
          supremeGroupIds: c.specificCriteria?.supremeGroupIds ?? [],
          levelIds: c.specificCriteria?.levelIds ?? [],
          genderIds: c.specificCriteria?.genderIds ?? [],
          styleIds: c.specificCriteria?.styleIds ?? [],
          divisionIds: c.specificCriteria?.divisionIds ?? [],
        },
      ],
    }));

    await this.TabulationService.saveAwardContestantCriteriaCreate(
      payload,         // body: List<ContestantCriteriaSetting>
      { awardId }      // query: ?awardId=123
    );
  }


  // ✅ Save Award FULL Criteria - testing
  async saveAwardFullCriteria(
    awardId: number,
    specificAwardFullCriteria: SpecificAwardFullCriteria
  ): Promise<void> {
    const { scoringCriteria, contestantCriteria, additionalScoringDetails } = specificAwardFullCriteria;

    if (!Array.isArray(scoringCriteria.customRules)) {
      throw new Error(
        `customRules is missing or invalid: ${JSON.stringify(scoringCriteria)}`
      );
    }

    console.log("🔎 Received awardId:", awardId);
    console.log("📥 Received criteria:", scoringCriteria);

    // 1) Normalize ScoringCriteria -> GeneralScoringCriteriaSettings (backend shape)
    const scoringCriteriaSettings: GeneralScoringCriteriaSettings = {
      dropLowestScore: scoringCriteria.dropLowestScore,
      dropHighestScore: scoringCriteria.dropHighestScore,
      customRules: scoringCriteria.customRules.map((rule) => ({
        topN: rule.topN,
        aocIds: rule.aocIds ?? [],
        aocNames: rule.aocNames ?? [],
        selectedAocType: rule.selectedAocType ?? undefined,
        selectedAocTypeId: rule.selectedAocTypeId ?? undefined,
        maxCountForSelectedAocType:
          typeof rule.maxCountForSelectedAocType === "string"
            ? parseInt(rule.maxCountForSelectedAocType as string, 10)
            : rule.maxCountForSelectedAocType ?? null,
        // prefer the new key, but gracefully fall back to the legacy one
        specificScoringCategoryIds:
          rule.scoringCategoryIds ??
          rule.scoringCategoryIds ??
          [],
      })),
    };

    // 2) Normalize ContestantCriteria -> GeneralScoringCriteriaSettings (backend shape)
    const contestantCriteriaSettings = (contestantCriteria ?? []).map(c => ({
      awardIndex: Math.max(1, Number(c.awardIndex ?? 1)),
      specificCriterias: [
        {
          ageGroupIds: c.specificCriteria?.ageGroupIds ?? [],
          supremeGroupIds: c.specificCriteria?.supremeGroupIds ?? [],
          levelIds: c.specificCriteria?.levelIds ?? [],
          genderIds: c.specificCriteria?.genderIds ?? [],
          styleIds: c.specificCriteria?.styleIds ?? [],
          divisionIds: c.specificCriteria?.divisionIds ?? [],
        },
      ],
      criteriaUiString: c.criteriaUIString,
    }));

    // 3) Map UI flags -> backend flags
    const backendAdditional = {
      titleId: awardId, // safe default
      useSupremeScoringCriteria: !!additionalScoringDetails?.isUseSupremeScoreSettings,
      calculationNeeded: !!additionalScoringDetails?.calculationNeededToFindWinner,
      doubleCrown: !!additionalScoringDetails?.isDoubleCrown,
    };

    // 4) Build backend payload
    const backendPayload = {
      scoringCriteriaSettings,
      additionalScoringDetails: backendAdditional,
      // send only if present (optional)
      ...(contestantCriteriaSettings.length > 0 && { contestantCriteriaSettings }),
    };

    console.log(
      "📦 Final FULL payload being sent to backend:",
      JSON.stringify(backendPayload, null, 2)
    );

    // 4) Call the new endpoint
    // Make sure your generated client has this method:
    // saveAwardFullCriteriaCreate(data: BackendSpecificAwardFullCriteria, query?: { awardId?: number })
    await this.TabulationService.saveAwardFullCriteria(
      backendPayload,   // body
      { awardId }       // query ?awardId=123
    );
  }



  //save additional scoring bools
  async saveAdditionalScoringDetails(
    titleId: number,
    useSupremeScoringCriteria: boolean,
    calculationNeeded: boolean,
    doubleCrown: boolean
  ): Promise<void> {
    const payload = {
      titleId,
      useSupremeScoringCriteria,
      calculationNeeded,
      doubleCrown,
    };

    console.log("Sending AdditionalScoringDetails payload:", payload);

    await this.TabulationService.saveAdditionalScoringDetailsCreate(payload);
  }

  //save additional scoring bools with additional logic for useSupremeScoring - testing
  async handleAdditionalScoringCriteriaToAward(
    awardId: number,
    pageantId: number,
    {
      useSupremeScoringCriteria,
      calculationNeeded,
      doubleCrown,
    }: {
      useSupremeScoringCriteria?: boolean; // ← make these optional
      calculationNeeded?: boolean;
      doubleCrown?: boolean;
    }
  ): Promise<void> {
    // 🔁 Use ToggleSupremeScoringCriteria ONLY when that flag is explicitly involved
    if (typeof useSupremeScoringCriteria === 'boolean') {
      console.log("🌟 Calling ToggleSupremeScoringCriteria for awardId", awardId);

      try {
        await this.TabulationService.saveUseSupremeScoringCriteriaForAward(
          awardId,
          useSupremeScoringCriteria,
          { pageantId }
        );
      } catch (error) {
        console.error("❌ Error toggling supreme scoring:", error);
        throw error;
      }

      return; // ⛔ Do not call SaveAdditionalScoringDetails afterwards
    }

    // ✅ Otherwise, update only the provided scoring details
    const payload: {
      titleId: number;
      useSupremeScoringCriteria?: boolean;
      calculationNeeded?: boolean;
      doubleCrown?: boolean;
    } = {
      titleId: awardId,
    };

    if (typeof calculationNeeded === 'boolean') {
      payload.calculationNeeded = calculationNeeded;
    }

    if (typeof doubleCrown === 'boolean') {
      payload.doubleCrown = doubleCrown;
    }

    console.log("📦 Saving AdditionalScoringDetails:", payload);

    try {
      await this.TabulationService.saveAdditionalScoringDetailsCreate(payload);
    } catch (error) {
      console.error("❌ Error saving additional scoring details:", error);
      throw error;
    }
  }



  async updateContestantAwardScore(contestantId: number, titleId: number, score: number): Promise<void> {
    try {
      await this.RegisteredContestantAwardRelationshipService.updateAwardScoreUpdate({
        contestantId,
        titleId,
        score // This will be the titleScore passed from the UI
      });
      console.log("Contestant award score updated successfully.");
    } catch (error) {
      console.error("Error updating contestant award score:", error);
      throw error;
    }
  }

  async getAwardTypes() {
    try {
      const awardTypeResult = await this.AwardTypesService.getAllAwardTypes();
      if (awardTypeResult.data.data) {
        this.AwardTypeList = awardTypeResult.data.data;
      }
    } catch (error) {
      console.error("Error fetching award types:", error);
    }
  }

async getStaffTabulatorAccessCodes(
  pageantId: number,
): Promise<StaffTabulatorAccessCodesDTO | null> {
  try {
    if (
      !pageantId ||
      pageantId <= 0
    ) {
      console.error(
        'Invalid pageant ID.',
      );

      return null;
    }

    const response =
      await this.TabulationService
        .getStaffTabulatorAccessCodes(
          pageantId,
        );

    return response.data ?? null;
  } catch (error) {
    console.error(
      `Failed to get staff tabulator access codes for pageantId ${pageantId}:`,
      error,
    );

    return null;
  }
}

async uploadResultsPdf(
  pageantId: number,
  file: File,
): Promise<boolean> {
  try {
    if (
      !pageantId ||
      pageantId <= 0
    ) {
      console.error(
        '[Upload Results PDF] Invalid pageantId.',
      );

      return false;
    }

    if (!file) {
      console.error(
        '[Upload Results PDF] No file provided.',
      );

      return false;
    }

    if (
      file.type &&
      file.type !==
        'application/pdf'
    ) {
      console.error(
        '[Upload Results PDF] File must be a PDF.',
      );

      return false;
    }

    await this.TabulationService
      .uploadResultsPdf(
        pageantId,
        {
          file,
        },
      );

    return true;
  } catch (error) {
    console.error(
      '[Upload Results PDF] API ERROR:',
      {
        pageantId,
        fileName:
          file?.name,
        error,
      },
    );

    return false;
  }
}

  async setShowModal(show: boolean) {
    console.log("Setting Show Modal:", show);
    this.ShowModal = show;
  }

  async setAllowEdit(allow: boolean) {
    this.AllowEdit = allow;
  }
}

let tabulationStore: TabulationStore;

export function GetTabulationStore() {
  if (!tabulationStore) {
    tabulationStore = new TabulationStore([]);
  }
  return tabulationStore;
}
